import { createAction, } from '@reduxjs/toolkit';
/**
 * `TArg` SERİLEŞTİRİLEBİLİR OLMAK ZORUNDADIR (bkz. `serializable-payload.ts`).
 * `File`/`Blob`/`Date`/`Map` gibi metot taşıyan bir tip verilirse `request`
 * yükü ulaşılamaz bir markaya düşer ve o eylemi ATAN ya da REDUCE EDEN her
 * satır DERLENMEZ. Doğru çözüm: dosya store dışında tutulur, eyleme tutamaç
 * geçer (`apps/web/src/shared/store/file-handle`).
 *
 * Kısıt `TArg extends …` biçiminde YAZILAMAZ (TS2313 — döngüsel kısıt); bu
 * yüzden denetim dönüş tipindedir.
 */
export function createAsyncActions(prefix) {
    return {
        prefix,
        request: createAction(`${prefix}/request`),
        success: createAction(`${prefix}/success`),
        failure: createAction(`${prefix}/failure`),
        cancel: createAction(`${prefix}/cancel`),
        reset: createAction(`${prefix}/reset`),
    };
}
export const initialAsyncState = {
    status: 'idle',
    error: null,
    lastLoadedAt: null,
    isStale: true,
};
export function isPayloadAction(action) {
    return typeof action === 'object' && action !== null && 'type' in action;
}
//# sourceMappingURL=async-actions.js.map